import { graphql } from "gatsby";
import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";
import React from "react";
import Helmet from "react-helmet";
import Container from "../components/container/Container";
import Layout from "../components/layout/layout";
import PortableText from "../components/portableText/portableText";
import { formatAsDate } from "../utils/format-utils";
import * as styles from "./BlogArticle.module.css";

export const query = graphql`
  query getBlogBySlug($slug: String!) {
    sanityBlogg(slug: { current: { eq: $slug } }) {
      publishedAt
      titleLong
      slug {
        current
      }
      authors {
        name
      }
      _rawIngress
      _rawBody
      _rawMainImageAlt
      mainImage {
        asset {
          gatsbyImageData(layout: FULL_WIDTH, formats: WEBP)
        }
      }
      helmetTitle
      helmetDescription
    }
  }
`;

const printOneAuthor = (name: string, index: number) => (
  <span key={index}>{name}</span>
);

const printMultipleAuthors = (authors: any) => {
  const authorString = authors.map((author: any, index: number) => {
    return author.name;
  });
  return authorString.join(", ").replace(/,(?=[^,]*$)/, " og ");
};

const BlogArticle = ({
  data: {
    sanityBlogg: {
      titleLong,
      _rawIngress,
      _rawBody,
      _rawMainImageAlt,
      slug,
      publishedAt,
      authors,
      mainImage,
      helmetTitle,
      helmetDescription,
    },
  },
}: {
  data: any;
}) => {
  return (
    <Layout>
      <Helmet>
        {helmetTitle ? <title>{helmetTitle}</title> : null}
        {helmetDescription ? (
          <meta name="description" content={helmetDescription} />
        ) : null}
        {titleLong ? <meta property="og:title" content={titleLong} /> : null}
        <meta property="og:type" content="article" />
        {mainImage ? (
          <meta
            property="og:image"
            content={mainImage.asset.gatsbyImageData.images.fallback.src}
          />
        ) : null}
        {helmetDescription ? (
          <meta property="og:description" content={helmetDescription} />
        ) : null}
      </Helmet>
      <Container>
        <div className="grid_vertical_padding bloggPost">
          <article>
            <div className={styles.introTextSection}>
              <h1>{titleLong}</h1>
              {_rawIngress && (
                <PortableText blocks={_rawIngress} className={styles.ingress} />
              )}

              <div className={styles.author}>
                <p className={`${styles.authorContent} mb-0`}>
                  {authors.length === 1
                    ? printOneAuthor(authors[0].name, 1)
                    : printMultipleAuthors(authors)}
                </p>
                <p className={styles.publishDate}>
                  {formatAsDate(publishedAt)}
                </p>
              </div>

              {mainImage && mainImage.asset && (
                <figure className={styles.mainImage}>
                  <div className="shadow">
                    {mainImage.asset.gatsbyImageData && (
                      <GatsbyImage
                        alt="" // TODO: Add alt
                        image={
                          mainImage.asset.gatsbyImageData as IGatsbyImageData
                        }
                      />
                    )}
                  </div>
                  <figcaption className={styles.mainImageCaption}>
                    <span>
                      {_rawMainImageAlt && (
                        <PortableText blocks={_rawMainImageAlt} />
                      )}
                    </span>
                  </figcaption>
                </figure>
              )}
            </div>
            <div className={styles.copyTextContainer}>
              {_rawBody && (
                <PortableText className={styles.copyText} blocks={_rawBody} />
              )}
            </div>
          </article>
        </div>
      </Container>
    </Layout>
  );
};
export default BlogArticle;
